// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import { IconWrapper } from "@insite/mobius/Icon";
import getProp from "@insite/mobius/utilities/getProp";
import { shareListModalStyles } from "@monsma/Overrides/Components/ShareListModal";
import { css } from "styled-components";

shareListModalStyles.modal = {
    size: 600,
};

shareListModalStyles.container = {
    gap: 15,
};

shareListModalStyles.shareListOptionGridItem = {
    css: css`
        display: none;
    `,
};

shareListModalStyles.shareListOptionRadioGroup = {};
shareListModalStyles.sendCopyRadio = {};
shareListModalStyles.shareListRadio = {};
shareListModalStyles.shareByOptionRadioGroup = {};
shareListModalStyles.shareByEmailRadio = {};
shareListModalStyles.shareByBillingRadio = {};

shareListModalStyles.allowEditingGridItem = {
    width: 12,
};

shareListModalStyles.buttonsContainer = {
    gap: 15,
    css: css`
        & ${GridOffset} {
            justify-content: flex-end;
        }
    `,
};

shareListModalStyles.cancelButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};

shareListModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

shareListModalStyles.sendButton = {
    variant: "primary",
};

shareListModalStyles.shareListOptionText = {
    css: css`
        margin-bottom: 20px;
    `,
};

shareListModalStyles!.xShareListModal = {
    tooltipWrapper: {
        css: css`
            display: flex;
            align-items: baseline;
            margin-top: 20px;
            gap: 5px;
        `,
    },
};

shareListModalStyles.shareListTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            ${getProp("theme.tooltip.defaultProps.cssOverrides.tooltipClickable")}
            margin-left: 5px;
            display: flex;
            align-items: center;
        `,
    },
};

shareListModalStyles.shareByEmailTooltip = shareListModalStyles.shareListTooltip;

shareListModalStyles.shareByBillingTooltip = shareListModalStyles.shareListTooltip;

shareListModalStyles.recipientEmailTooltip = {
    cssOverrides: {
        tooltipContainer: css`
            ${getProp("theme.tooltip.defaultProps.cssOverrides.tooltipContainer")}
            min-width: 200px;
        `,
        tooltipClickable: css`
            pointer-events: initial;
            z-index: 1;
        `,
    },
    typographyProps: {
        color: "text.main",
    },
};

shareListModalStyles.recipientEmailAddressTextField = {
    cssOverrides: {
        formInputWrapper: css`
            ${IconWrapper} {
                pointer-events: all;
            }
        `,
    },
};
